const CONFIG = {};

if (process.env.VUE_APP_API_ROOT) {
    CONFIG.API_ROOT = process.env.VUE_APP_API_ROOT;
} else {
    CONFIG.API_ROOT = (process.env.NODE_ENV === 'production') ? 'https://api.exploratufuturo.org/api' : 'http://localhost:8000/api';
}

CONFIG.VERSION = process.env.PACKAGE_VERSION || '0';

CONFIG.COLORS = {
    pensum: {
        cuantitative: '#6342cb',
        cualitative: '#f3c625',
        optative: '#04c2ca',
        profesional: '#fb2453',
    },
    salary: {
        career: '#fb2453',
        area: '#04c2ca',
    },
    partners: {
        Lenguaje: '#6342cb',
        Matemáticas: '#f3c625',
        'Ciencias Naturales': '#04c2ca',
        'Ciencias Sociales': '#fb2453',
        'Lengua Española': '#6342cb',
    },
    shadows: {
        career: '#670318',
        area: '#011616',
    },
};

CONFIG.textForTabs = [
    {
        barTitle: 'Salario promedio de egresados de esta carrera versus salario promedio de otras carreras de la misma área de estudio.',
        barSubtitle: '(Estas cifras corresponden a egresados con características similares a TI)',
        lineTitle: 'Distribución de salarios de esta carrera versus distribución de salarios de otras carreras de la misma área de estudio.',
        lineSubtitle: '(Estas cifras corresponden a egresados con características similares a TI)',
        videoTitle: '',
        videoSubtitle: '',
        bar: ' <b>Notas:</b> Estas cifras corresponden a egresados con características similares a TI (mismo género, tipo de institución educativa y similar desempeño en las Pruebas Nacionales). La altura de la barra roja corresponde al salario promedio de egresados de esta carrera, mientras que la barra azul corresponde al salario promedio de egresados de otras carreras similares en la misma área de estudio.',
        line: ' Notas: Estas cifras corresponden a egresados con características similares a TI (mismo género, tipo de institución educativa y similar desempeño en las Pruebas Nacionales). La altura de las barras corresponde al porcentaje de egresados que se encuentra en cada rango de salarios. ',
        video: '',
    },
    {
        title: 'Nivel de empleabilidad de esta carrera versus nivel de empleabilidad de otras carreras de la misma área de estudio.',
        subtitle: '(Estas cifras corresponden a egresados con características similares a TI)',
        text: 'Notas:<br /> Estas cifras corresponden a egresados con características similares a TI (mismo género, tipo de institución educativa y similar desempeño en las Pruebas Nacionales).<br /> La altura de la barra roja corresponde al nivel de empleo de los egresados de la carrera, mientras que la barra azul corresponde al nivel de empleo de egresados de otras carreras similares (misma área de estudio).<br /> Visita "Fuentes de datos" para más detalles sobre cómo fue construida esta estadística.',
    },
    {
        barTitle: 'Tus puntajes en Pruebas Nacionales versus los puntajes obtenidos por los egresados de esta carrera',
        barSubtitle: '',
        lineTitle: 'Posición de tus puntajes con respecto a los puntajes de los otros egresados de esta carrera.',
        lineSubtitle: '',
        bar: '',
        line: 'Este gráfico nos muestra cómo se distribuyen los egresados, desde los que han tenido un menor puntaje en las pruebas a los con mayor puntaje. Las barras muestran la cantidad de egresados con cada puntaje, mientras más alta, más egresados tienen ese puntaje. Con un círculo está marcado TU PUNTAJE.',
    },
    {
        avgCuanTitle: 'Porcentaje de cursos cuantitativos de esta carrera versus otras carreras de la misma área de estudios.',
        avgCuanSubtitle: '',
        avgCualTitle: 'Porcentaje de cursos cualitativos de esta carrera versus otras carreras de la misma área de estudios.',
        avgCualSubtitle: '',
        disCuanTitle: 'Si ordenamos todas las carreras de República Dominicana según su porcentaje de cursos cuantitativos, esta carrera se ubica en la barra destacada. ',
        disCuanSubtitle: '',
        disCualTitle: 'Si ordenamos todas las carreras de República Dominicana según su porcentaje de cursos cualitativos, esta carrera se ubica en la barra destacada. ',
        disCualSubtitle: '',
        otherTitle: 'Composición del Plan de Estudio (Pensum) de esta carrera ',
        otherSubtitle: '(Promedio de todas las instituciones que imparten la carrera)',
        avg_cuan: ' <b>Notas:</b> <br /> La altura de la barra oscura corresponde al porcentaje de cursos cuantitativos que tiene esta carrera, mientras que la altura de la barra clara corresponde a carreras similares en la misma área de estudio. <br /> <br /> Los cursos cuantitativos corresponden a los cursos de Ciencias, Tecnologías, Ingenierías y Matemáticas. ',
        avg_cual: '<b>Notas:</b> <br /> La altura de la barra oscura corresponde al porcentaje de cursos cuantitativos que tiene esta carrera, mientras que la altura de la barra clara corresponde a carreras similares en la misma área de estudio. <br /> <br /> Los cursos cualitativos corresponden a los de Humanidades, Derecho, Idiomas, Educación y Artes.',
        d_cuan: '<b>Notas:</b> <br /> Aquí están ordenadas todas las carreras, desde la con menos cursos cualitativos a los con más cursos cualitativos. La barra destacada indica dónde se ubica esta carrera. <br /> <br /> Los cursos cuantitativos corresponden a los cursos de Ciencias, Tecnologías, Ingenierías y Matemáticas. ',
        d_cual: '<b>Notas:</b> <br /> Aquí están ordenadas todas las carreras, desde la con menos cursos cualitativos a los con más cursos cualitativos. La barra destacada indica dónde se ubica esta carrera. <br /><br />Los cursos cualitativos corresponden a los de Humanidades, Derecho, Idiomas, Educación y Artes. ',
        other: '<b>Notas:</b><br /> Las cifras corresponden al promedio de las universidades que imparten esta carrera. <br /> <br />Los <b>cursos cuantitativos</b> corresponden a los cursos de Ciencias, Tecnologías, Ingenierías y Matemáticas. <br /><br /> Los <b>cursos cualitativos</b> corresponden a los de Humanidades, Derecho, Idiomas, Educación y Artes.',
    },
];

CONFIG.textForSquares = {
    ciclos: 'Total de ciclos de la carrera',
    creditos: 'Total de créditos de la carrera',
    practicas: 'Total de horas prácticas a la semana',
    teoricas: 'Total de horas teóricas a la semana',
};

CONFIG.responsive = {
    minWidth: 680,
    minWithInfoChart: 600,
    compressDictionary: ['Mat', 'Leng', 'Soc', 'Nat'],
};

CONFIG.footer = {
    disclaimer: 'Estás viendo la versión beta de la página, estamos trabajando por mejorarla y por lo tanto, algunos datos pueden cambiar.',
};


export default CONFIG;
